<div class="box">
    <h2 class="icon-pfinder icon-size-6 bigger">Produktfinder</h2>
    <p class="mb-2">Suchen Sie einfach nach <b>Brother Geräten</b> oder <b>Geräten anderer Hersteller:</b></p>
    <div class="d-flex my-1">
        <input type="text" placeholder="Nach beliebigem Gerät suchen" class="search" [(ngModel)]="model.searchTerm" (keydown.enter)="search()">
        <button class="btn big btn-transparent" (click)="search()">Suchen</button>
    </div>
    <div class="text-with-line small my-2">
        <span>Oder suchen sie Brother Geräte nach Kategorien:</span>
    </div>
    <div class="d-flex">
        <div class="icon-checkbox">
            <a [routerLink]="['/products','product-finder', 'category', 'scanner']">
                <!-- <input type="checkbox" id="scannen"> -->
<!--                <label for="scannen" class="icon-scanner"-->
<!--                       (click)="onHtmlItemClicked(TrackingCalledSectionDashboardEnum.HOME_FILTER_BROTHER_SCANNER)"></label>-->
                <div class="icon-container" (click)="onHtmlItemClicked(TrackingCalledSectionDashboardEnum.HOME_FILTER_BROTHER_SCANNER)">
                    <img src="./assets/img/scanner-icon.png" alt="icon scanner">
                </div>
            </a>
            <span>Scanner</span>
        </div>
        <div class="icon-checkbox">
            <a [routerLink]="['/products','product-finder', 'category', 'printer']">
                <!-- <input type="checkbox" id="drucken"> -->
                <div class="icon-container" (click)="onHtmlItemClicked(TrackingCalledSectionDashboardEnum.HOME_FILTER_BROTHER_PRINTER)">
                    <img src="./assets/img/drucker-icon.png" alt="icon drucker">
                </div>
            </a>
            <span>Drucker</span>
        </div>

        <div class="icon-checkbox">
            <a [routerLink]="['/products', 'product-finder', 'category', 'mfc']">
                <!-- <input type="checkbox" id="multifunction"> -->
                <label class="icon-multifunktion"
                       (click)="onHtmlItemClicked(TrackingCalledSectionDashboardEnum.HOME_FILTER_BROTHER_MF)"></label>
            </a>
            <span>Multifunk.</span>
        </div>
        <div class="icon-checkbox">
            <a [routerLink]="['/products', 'product-finder', 'category', 'labeler']">
                <!-- <input type="checkbox" id="beschrift"> -->
                <label class="icon-beschriftung"
                       (click)="onHtmlItemClicked(TrackingCalledSectionDashboardEnum.HOME_FILTER_BROTHER_LABELER)"></label>
            </a>
            <span>Beschrift.</span>
        </div>
        <div class="icon-checkbox">
            <a [routerLink]="['/products', 'product-finder', 'category', 'fax']">
                <!-- <input type="checkbox" id="fax"> -->
                <div class="icon-container" (click)="onHtmlItemClicked(TrackingCalledSectionDashboardEnum.HOME_FILTER_BROTHER_FAX)">
                    <img src="./assets/img/fax-icon.png" alt="icon fax">
                </div>
            </a>
            <span>Faxgeräte</span>
        </div>
        <div class="icon-checkbox">
            <a [routerLink]="['/solutions']">
                <!-- <input type="checkbox" id="losungen"> -->
                <label class="icon-loesungen"
                       (click)="onHtmlItemClicked(TrackingCalledSectionDashboardEnum.HOME_SHOW_BROTHER_SOLUTIONS)"></label>
            </a>
            <span>Lösungen</span>
        </div>
    </div>
</div>
